module.exports = __webpack_public_path__ + "static/media/digital-school.96fd66a1.jpg";